import "core-js/modules/es6.regexp.replace.js";

/**
 * @constant {Object}
 * @desc Different actions used to set action in element_interacted events
 */
export var ACTION = {
  SELECT: 'select',
  NAVIGATE: 'navigate',
  CLOSE: 'close',
  OPEN: 'open',
  CONFIRM: 'confirm',
  CANCEL: 'cancel',
  HIDDEN: 'hidden',
  VISIBLE: 'visible',
  SAVE: 'save'
};
/**
 * @constant {Object}
 * @desc List of entity names used in analytics events
 */

export var ENTITY_NAME = {
  COMPARISON_GRID: 'comparison_grid',
  COMPARISON_GRID_ADD_ENTITY: 'comparison_grid_add_entity',
  COMPARISON_GRID_BACK: 'comparison_grid_back',
  COMPARISON_GRID_CLOSE: 'comparison_grid_close',
  COMPARISON_GRID_ENTITY_SEARCH: 'comparison_grid_entity_search',
  COMPARISON_GRID_NAVIGATE: 'comparison_grid_navigate',
  COMPARISON_GRID_PRODUCT_ENTITIES: 'comparison_grid_product_entities',
  COMPARISON_GRID_REMOVE_ENTITY: 'comparison_grid_remove_entity',
  COMPARISON_GRID_SKITTLE: 'comparison_grid_skittle',
  COMPARISON_GRID_SKITTLE_CONTENT: 'comparison_grid_skittle_content',
  COMPARISON_GRID_TAB: 'comparison_grid_tab',
  COMPARISON_GRID_TAB_CONTENT: 'comparison_grid_tab_content',
  SAVE_COMPARE_CARDS_BUTTON: 'save_compare_cards_button',
  SAVE_COMPARE_CARDS_BUTTON_PRESSED: 'save_compare_cards_button_pressed',
  COMPARE_PAGE_CTA: 'compare_page_cta',
  SECONDARY_CTA: 'secondary_cta',
  SHOPPING_PRODUCT_ENTITY: 'shopping_product_entity',
  STICKY_BANNER: 'pl_prequal_offer_compare_banner',
  STICKY_BANNER_COMPARE_BUTTON: 'pl_prequal_offer_compare_confirm',
  STICKY_BANNER_RESET_BUTTON: 'pl_prequal_offer_compare_reset',
  PREQUAL_OFFER_PRODUCT_IMPRESSION: 'pl_prequal_offer_product_impression'
};
/**
 * @constant {Object}
 * @desc Different event types to set event_type in analytics events
 */

export var EVENT_TYPES = {
  ELEMENT_IMPRESSION: 'element_impression',
  ELEMENT_INTERACTED: 'element_interacted',
  FORM_CANCELLED: 'form_cancelled',
  FORM_IMPRESSION: 'form_impression',
  MARKETPLACE_OFFERS_IMPRESSION: 'marketplace_offers_impression',
  PRODUCT_IMPRESSION: 'product_impression'
};
/**
 * @constant {Object}
 * @desc Different interaction types to set interaction_type in element_interacted events
 */

export var INTERACTION_TYPE = {
  PRESS: 'press'
};
/**
 * @constant {Object}
 * @desc Directions used for pagination.
 */

export var DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right'
};
/**
 * @constant {Object}
 * @desc Different form names used for form events
 */

export var FORM_NAME = {
  COMPARISON_GRID_ADD_ENTITY: 'comparison_grid_add_entity'
};
/**
 * @constant {Object}
 * @desc Different Monetizing values used to indicated monetizing field in product_impressions
 */

export var MONETIZING = {
  NO: 'no',
  YES_ASSUMED: 'yes_assumed'
};
export var SECTION_NAME = {
  COMPARISON_GRID_POPOVER: 'comparison_grid_popover',
  PREQUAL_RESULTS: 'pl_prequal_offer_compare',
  SELECTED_CARDS_TAB: 'selected_cards_tab'
};
/**
 * Makes sure that the entity name is valid for analytics if we build it.
 * @param {String} entityName
 */

export var buildAnalyticsEntityName = function buildAnalyticsEntityName(entityName) {
  return entityName === null || entityName === void 0 ? void 0 : entityName.toLowerCase().replace(/ |\W/g, '_').substring(0, 64);
};